import service from 'services/fetchInterceptor';
import {
  PropertyPayload,
  MintPayload,
  ServiceType,
  ListPayload,
} from './types';

const propertyService: ServiceType | any = {};

propertyService.createProperty = (data: PropertyPayload) =>
  service({ url: '/property', method: 'POST', data });

propertyService.mintProperty = (data: MintPayload) =>
  service({ url: '/property/mint', method: 'POST', data });

propertyService.addTokenIdToMintedProperty = (data: MintPayload) =>
  service({ url: '/property/mint', method: 'PATCH', data });

propertyService.getProperty = (propertyId: string) =>
  service({ url: `/property/${propertyId}`, method: 'GET' });

propertyService.listProperty = (propertyId: string, data: ListPayload) =>
  service({ url: `/property/list/${propertyId}`, method: 'PATCH', data });

propertyService.unlistProperty = (propertyId: string) =>
  service({ url: `/property/unlist/${propertyId}`, method: 'PATCH' });

propertyService.sellProperty = (propertyId: string, data: ListPayload) =>
  service({ url: `/property/sold/${propertyId}`, method: 'PATCH', data });

export default propertyService;
